export default function RelatedLinksSection() {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
          DMM FXについてさらに詳しく知りたい方は、こちらの記事も参考にしてください。
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          <a
            href="/campaign"
            className="group p-6 bg-gradient-to-br from-red-50 to-red-100 rounded-xl hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              <i className="ri-gift-line text-2xl text-red-600"></i>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-red-600 transition-colors">
                キャンペーン情報
              </h3>
            </div>
            <p className="text-sm text-gray-600">
              お得なキャンペーンをチェック
            </p>
          </a>

          <a
            href="/deposit-withdrawal"
            className="group p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              <i className="ri-bank-line text-2xl text-blue-600"></i>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                入出金方法
              </h3>
            </div>
            <p className="text-sm text-gray-600">
              入出金の手順と注意点
            </p>
          </a>

          <a
            href="/app-guide"
            className="group p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              <i className="ri-smartphone-line text-2xl text-purple-600"></i>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-purple-600 transition-colors">
                アプリの使い方
              </h3>
            </div>
            <p className="text-sm text-gray-600">
              スマホアプリの機能と使い方
            </p>
          </a>

          <a
            href="/beginner-guide"
            className="group p-6 bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              <i className="ri-book-open-line text-2xl text-emerald-600"></i>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-emerald-600 transition-colors">
                初心者ガイド
              </h3>
            </div>
            <p className="text-sm text-gray-600">
              FX初心者でも安心して始められる
            </p>
          </a>
        </div>
      </div>
    </section>
  );
}
